import { setContext } from '@apollo/client/link/context';
import type { MutableRefObject } from 'react';

type AnnotateRequestHeadersLinkProps = {
  requestHeadersRef?: MutableRefObject<Record<string, string> | undefined>;
};

export function AnnotateRequestHeadersLink({
  requestHeadersRef,
}: AnnotateRequestHeadersLinkProps) {
  return setContext(async (_, previousContext) => {
    // stored as separate variable to make debugging easier
    const output = {
      ...(previousContext || {}),
      headers: {
        ...(previousContext?.headers || {}),
        ...(requestHeadersRef?.current || {}),
      },
    };

    return output;
  });
}
